import * as remoteAction from "../remoteAction";

export type GetLedgerActivityActionSuccess =
  remoteAction.MerchantRemoteResponse<
    "GET_CUSTOMER_LEDGER_ACTIVITY_SUCCESS",
    any
  >;
export type GetLedgerActivityActionFailure =
  remoteAction.MerchantRemoteResponse<
    "GET_CUSTOMER_LEDGER_ACTIVITY_FAILURE",
    any
  >;
export type GetLedgerActivityActionRequest =
  remoteAction.MerchantRemoteResponse<
    "GET_CUSTOMER_LEDGER_ACTIVITY_REQUEST",
    any
  >;

export interface GetLedgerActivityAction extends remoteAction.GetRemoteRequest {
  types: {
    request: "GET_CUSTOMER_LEDGER_ACTIVITY_REQUEST";
    success: "GET_CUSTOMER_LEDGER_ACTIVITY_SUCCESS";
    failure: "GET_CUSTOMER_LEDGER_ACTIVITY_FAILURE";
  };
}

export function getLedgerActivityAction(): GetLedgerActivityAction {
  return {
    method: "GET",
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      failure: "GET_CUSTOMER_LEDGER_ACTIVITY_FAILURE",
      request: "GET_CUSTOMER_LEDGER_ACTIVITY_REQUEST",
      success: "GET_CUSTOMER_LEDGER_ACTIVITY_SUCCESS",
    },
    https: true,
    url: `/analytics/loyalty-dashboard/customer-ledger-activity?pageSize=200`,
  };
}
